export enum SwitchWidget {
  On = 'EwAR',
  Mixed = '80C2',
  Off = 'ynmB',
}
